"use strict";
/*
 * Created on 19. 9. 2018
 *
 * Copyright (c) 2018 Etnetera, a.s. All rights reserved.
 * Intended for internal use only.
 * http://www.etnetera.cz
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var ValueWithUnitConverter_1 = require("../../../core/conversions/ValueWithUnitConverter");

var SelloutReleaseItemSupplyData_1 = require("../../model/sellout/SelloutReleaseItemSupplyData");

var SelloutReleaseItemSupplyDataConverter_1 = require("./SelloutReleaseItemSupplyDataConverter");
/**
 * Default implementation of release item converter.
 *
 * @author Radek Beran
 */


var SelloutReleaseItemSupplyDataConverterImpl =
/*#__PURE__*/
function (_SelloutReleaseItemSu) {
  _inherits(SelloutReleaseItemSupplyDataConverterImpl, _SelloutReleaseItemSu);

  function SelloutReleaseItemSupplyDataConverterImpl() {
    _classCallCheck(this, SelloutReleaseItemSupplyDataConverterImpl);

    return _possibleConstructorReturn(this, _getPrototypeOf(SelloutReleaseItemSupplyDataConverterImpl).call(this));
  }
  /**
   * @inheritDoc
   */


  _createClass(SelloutReleaseItemSupplyDataConverterImpl, [{
    key: "toObject",
    value: function toObject(source, conversions) {
      return new SelloutReleaseItemSupplyData_1.SelloutReleaseItemSupplyData(SelloutReleaseItemSupplyData_1.SelloutReleaseItemSupplyData.schema.availableSupply.valueOf(conversions.asObject(source, 'availableSupply', ValueWithUnitConverter_1.ValueWithUnitConverter.deserialize(conversions))), SelloutReleaseItemSupplyData_1.SelloutReleaseItemSupplyData.schema.amount.valueOf(conversions.asObjectOpt(source, 'amount', ValueWithUnitConverter_1.ValueWithUnitConverter.deserialize(conversions))), SelloutReleaseItemSupplyData_1.SelloutReleaseItemSupplyData.schema.availableSupplyBeforeRepricing.valueOf(conversions.asObjectOpt(source, 'availableSupplyBeforeRepricing', ValueWithUnitConverter_1.ValueWithUnitConverter.deserialize(conversions))), SelloutReleaseItemSupplyData_1.SelloutReleaseItemSupplyData.schema.amountBeforeRepricing.valueOf(conversions.asObjectOpt(source, 'amountBeforeRepricing', ValueWithUnitConverter_1.ValueWithUnitConverter.deserialize(conversions))), SelloutReleaseItemSupplyData_1.SelloutReleaseItemSupplyData.schema.supplyLastInDays.valueOfField(source), SelloutReleaseItemSupplyData_1.SelloutReleaseItemSupplyData.schema.delistedFrom.valueOfField(source), SelloutReleaseItemSupplyData_1.SelloutReleaseItemSupplyData.schema.lastPurchase.valueOfField(source));
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "toDocument",
    value: function toDocument(source, conversions) {
      var result = {};
      Object.assign(result, {
        availableSupply: conversions.asObject(source, 'availableSupply', ValueWithUnitConverter_1.ValueWithUnitConverter.serialize(conversions)),
        amount: conversions.asObjectOpt(source, 'amount', ValueWithUnitConverter_1.ValueWithUnitConverter.serialize(conversions)),
        availableSupplyBeforeRepricing: conversions.asObjectOpt(source, 'availableSupplyBeforeRepricing', ValueWithUnitConverter_1.ValueWithUnitConverter.serialize(conversions)),
        amountBeforeRepricing: conversions.asObjectOpt(source, 'amountBeforeRepricing', ValueWithUnitConverter_1.ValueWithUnitConverter.serialize(conversions)),
        supplyLastInDays: source.supplyLastInDays,
        delistedFrom: source.delistedFrom ? conversions.fromDate(source.delistedFrom) : null,
        lastPurchase: source.lastPurchase ? conversions.fromDate(source.lastPurchase) : null
      });
      return result;
    }
  }]);

  return SelloutReleaseItemSupplyDataConverterImpl;
}(SelloutReleaseItemSupplyDataConverter_1.SelloutReleaseItemSupplyDataConverter);

exports.SelloutReleaseItemSupplyDataConverterImpl = SelloutReleaseItemSupplyDataConverterImpl;